import { Dispatch, FC, ReactNode, SetStateAction, useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IArchivedStatusRequest } from 'Data/interfaces/Obra/IArchivedStatusRequest';
import { ObraActions } from 'Store/Obra/Obra.actions';
import { getTheme } from 'Store/MultiDomain/MultiDomain.selector';
import Modal from 'Components/UI/Modal';
import Button from 'Components/UI/Button';
import SpinCustom from 'Components/UI/SpinCustom';
import { ObraArquivadaStyled, TextWrap } from './styles';

export interface IObraArquivada {
  avatar: ReactNode;
  name: string;
  ConstructionSiteId: number;
  currentPeperUser?: number;
  activeObras: number;
  maxObras?: number;
  setModalContaUpgradeVisible: Dispatch<SetStateAction<boolean>>;
  isLoading?: boolean;
}

const ObraArquivada: FC<IObraArquivada> = ({
  avatar,
  name,
  ConstructionSiteId,
  currentPeperUser,
  activeObras,
  maxObras,
  setModalContaUpgradeVisible,
  isLoading,
}) => {
  const { t } = useTranslation('obras');
  const dispatch = useDispatch();

  const { colors } = useSelector(getTheme);
  const [isAlertModal, setIsAlertModal] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);

  const desarquivarObra = () => {
    if (maxObras && activeObras >= maxObras) {
      setModalContaUpgradeVisible(true);

    } else {
      setIsAlertModal(true);
    }
  };

  const confirmDesarquivarObra = () => {
    const status: IArchivedStatusRequest = {
      ConstructionSiteId,
      isArchived: false,
    };
    dispatch(ObraActions.updateArchivedStatus(status));
    setIsSubmited(true);
  };

  const buttons = (
    <div>
      <Button height={37} onClick={() => setIsAlertModal(false)}>
        <span style={{ padding: '0 18px' }}>{t('archived.cancel')}</span>
      </Button>
      <Button
        type='primary'
        height={37}
        disabled={isLoading}
        onClick={() => confirmDesarquivarObra()}
      >
        {isLoading && (
          <SpinCustom
            size={12}
            color={colors.primary.onPrimary}
            marginRigth={6}
          />
        )}
        <span style={{ padding: '0 18px' }}>{t('archived.confirmUnarchive')}</span>
      </Button>
    </div>
  );

  useEffect(() => {
    if (!isLoading && isSubmited) {
      setIsAlertModal(false);
      setIsSubmited(false);
    }
  }, [isLoading, isSubmited]);

  return (
    <ObraArquivadaStyled>
      <div>
        {avatar}
        <strong>{name}</strong>
      </div>
      {(currentPeperUser === 1 || currentPeperUser === 7) && (
        <span onClick={() => desarquivarObra()} className='linkDesarquivar'>{t('archived.unarchive')}</span>
      )}
      <Modal
        title={t('archived.unarchiveModalTitle')}
        footerButtons={buttons}
        visible={isAlertModal}
        width={450}
        onCancel={() => setIsAlertModal(false)}
      >
        <TextWrap>
          <Trans
            i18nKey="archived.unarchiveConfirmation"
            ns="obras"
            values={{ name }}
            components={[<strong />]}
          />
        </TextWrap>
      </Modal>
    </ObraArquivadaStyled>
  );
};

export default ObraArquivada;
